import { render, staticRenderFns } from "./pay-vip-dialog.vue?vue&type=template&id=db2c3cd4&scoped=true"
import script from "./pay-vip-dialog.vue?vue&type=script&lang=js"
export * from "./pay-vip-dialog.vue?vue&type=script&lang=js"
import style0 from "./pay-vip-dialog.vue?vue&type=style&index=0&id=db2c3cd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2c3cd4",
  null
  
)

export default component.exports